import React from 'react';
import { authProtectedRoutes } from 'helpers/customNavigationRules';
import PropTypes from 'prop-types';

import HeaderMenuItem, { NativeHeaderMenuItem } from './HeaderMenuItem';

export const HeaderMenuList = ({ className, hasNativeLinks, isFake = false, items }) => {
  const Component = hasNativeLinks ? NativeHeaderMenuItem : HeaderMenuItem;

  return (
    <menu className={className}>
      {items.map(({ active, children, id, location, name, onClick, onClickMore }) => (
        <Component
          authRequired={authProtectedRoutes.includes(location)}
          hasNativeLinks={hasNativeLinks}
          id={id}
          isFake={isFake}
          isMoreActive={active}
          key={name}
          label={name}
          link={location}
          onClick={onClick}
          onClickMore={onClickMore}
          subpages={children}
        />
      ))}
    </menu>
  );
};

HeaderMenuList.propTypes = {
  className: PropTypes.string,
  hasNativeLinks: PropTypes.bool,
  isFake: PropTypes.bool,
  items: PropTypes.arrayOf(PropTypes.object),
};
